import { DEFAULT_ENCARTE_MODEL } from "../components/WorkSpace/CanvasViewer/EncarteConstants";
import Styles from "./Styles";
export default function Encarte(
  name = `Encarte do dia ${new Date().getDate()}/${
    new Date().getMonth() + 1
  }/${new Date().getFullYear()}`,
  modelUrl = `${DEFAULT_ENCARTE_MODEL}`,
  styles = Styles(),
  products = [],
) {
  return {
    name: name,
    styles: styles,
    products: products,
    modelUrl: modelUrl,
  };
}
